import { Injectable } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({providedIn: 'root'})
export class SnackBarService {
    constructor(private snackBar: MatSnackBar) {
    }

    public show(message: string) {
        this.snackBar.open(message, 'x', {
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            duration: 2000
        });
    }
}
